import { render, staticRenderFns } from "./SjChildrenUserWindow.vue?vue&type=template&id=12b2c158&scoped=true&"
import script from "./SjChildrenUserWindow.vue?vue&type=script&lang=js&"
export * from "./SjChildrenUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./SjChildrenUserWindow.vue?vue&type=style&index=0&id=12b2c158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2c158",
  null
  
)

export default component.exports